// src/components/directory/SearchBar.jsx
// Covers: DS-01 (keyword search), DS-07 hook-in point for AI search

import React, { useRef } from 'react';
import styles from './SearchBar.module.css';

export default function SearchBar({ value, onChange, onAiClick }) {
  const inputRef = useRef(null);

  return (
    <div className={styles.row}>
      <div className={styles.inputWrap}>
        <SearchIcon className={styles.icon} />
        <input
          ref={inputRef}
          type="text"
          className={styles.input}
          placeholder="Search by program name, service type, or keyword…"
          value={value}
          onChange={e => onChange(e.target.value)}
          aria-label="Search programs"
        />
        {value && (
          <button
            className={styles.clearBtn}
            onClick={() => { onChange(''); inputRef.current?.focus(); }}
            aria-label="Clear search"
          >
            ✕
          </button>
        )}
      </div>
      <button className={styles.aiBtn} onClick={onAiClick}>
        ✦ Ask AI
      </button>
    </div>
  );
}

function SearchIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <circle cx="9" cy="9" r="6" />
      <path d="M15 15l3 3" strokeLinecap="round" />
    </svg>
  );
}
